import React from 'react';
import * as ReactDOM from 'react-dom';

type Props = {
    type: string,
    message: string,
    duration?: number,
}
type State = {
    isVisible: boolean,
}

const messageRoot = document.getElementById('application-messages');

class FlashMessage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { isVisible: true };
    }

    timer?: ReturnType<typeof setTimeout>;

    componentDidMount() {
        this.timer = setTimeout(() => this.hide(), this.props.duration || 2000)
    }

    componentWillUnmount() {
        this.timer && clearTimeout(this.timer);
    }

    hide() {
        this.setState({ isVisible: false });
    }

    getClass(type: string) {
        if (type === 'error') return 'danger';
        return type;
    }

    render() {
        const { isVisible } = this.state;
        if (!isVisible) return null;

        const { message, type } = this.props;

        return ReactDOM.createPortal((
            <div className={`application-message alert alert-${this.getClass(type)}`}>
                {message}
            </div>
        ), messageRoot!);
    }
}

export default FlashMessage;
